export const styles = {
	notificationText: {
		fontWeight: "bold",
		color: "#666666",
		textAlign: "start",
		padding: "0.5rem",
	},
};
